import React, { useEffect, useState, useRef } from 'react';
import { Button, notification, Spin } from 'antd';
import { useHistory } from 'react-router';
import { getCore, Reference } from 'cvat-core-wrapper';
import { useSelector } from 'react-redux';
import { CombinedState } from 'reducers';

const core = getCore();

const ReferenceLastJob: React.FC = () => {
    const history = useHistory();
    const reference = useSelector((state: CombinedState) => state.references.current[0]);
    const [referenceInstance, setReferenceInstance] = useState<Reference | null>(null);
    const [fetchingReference, setFetchingReference] = useState(true);
    const mounted = useRef(false);

    const receiveReference = (): void => {
        if (Number.isInteger(reference.id)) {
            core.references
                .get({ id: reference.id })
                .then(([reference]: Reference[]) => {
                    if (reference && mounted.current) {
                        setReferenceInstance(reference);
                    }
                })
                .catch((error: Error) => {
                    if (mounted.current) {
                        notification.error({
                            message: 'Could not receive the requested reference from the server',
                            description: error.toString(),
                        });
                    }
                })
                .finally(() => {
                    if (mounted.current) {
                        setFetchingReference(false);
                    }
                });
        }
    };

    useEffect(() => {
        mounted.current = true;
        receiveReference();

        return () => {
            mounted.current = false;
        };
    }, [reference]);

    if (fetchingReference) {
        return <Spin size='default' />;
    }

    const jobs = referenceInstance.jobs || [];

    return (
        <div>
            <Button
                disabled={fetchingReference || !referenceInstance}
                className='cvat-item-open-reference-button'
                type='primary'
                size='large'
                ghost
                onClick={() => history.push(`/references/${reference.id}/jobs/${jobs[0].id}`)}
            >
                Open
            </Button>
        </div>
    );
};

export default ReferenceLastJob;
